/**
 * 脚本面板（M4-09 / DESIGN.md#65-值得从-photoshop-补充的功能性价比排序）。
 *
 * 纯展示组件：一个 `<textarea>` 编辑器（不引入代码编辑器库——CLAUDE.md
 * 规则 7 不允许为了语法高亮这种加分项引入新框架级依赖）+ 运行按钮 +
 * 输出日志。跑脚本的编排逻辑（Worker 生命周期）在 `app/scripting/sandbox.ts`。
 */
import type { JSX } from 'solid-js';
import { For, createSignal } from 'solid-js';
import styles from './ScriptPanel.module.css';

export interface ScriptPanelProps {
  readonly running: boolean;
  readonly onRun: (code: string) => void;
  readonly onStop: () => void;
  readonly log: readonly string[];
}

const DEFAULT_CODE = `// 脚本在独立 Worker 里跑，通过 api 与文档交互
const doc = await api.getDocument();
log('文档:', doc);
`;

export function ScriptPanel(props: ScriptPanelProps): JSX.Element {
  const [code, setCode] = createSignal(DEFAULT_CODE);

  return (
    <div class={styles.panel} data-testid="script-panel">
      <textarea
        class={styles.editor}
        data-testid="script-editor"
        value={code()}
        spellcheck={false}
        onInput={(event) => setCode(event.currentTarget.value)}
      />
      <div class={styles.actions}>
        <button
          type="button"
          class={styles.runButton}
          data-testid="script-run"
          disabled={props.running}
          onClick={() => props.onRun(code())}
        >
          ▶ 运行
        </button>
        <button
          type="button"
          class={styles.stopButton}
          data-testid="script-stop"
          disabled={!props.running}
          onClick={() => props.onStop()}
        >
          ■ 停止
        </button>
      </div>
      <pre class={styles.output} data-testid="script-output">
        <For each={props.log}>{(line) => <div>{line}</div>}</For>
      </pre>
    </div>
  );
}
